<template>
	<div :class="['input', { 'has-error': errorMessage.length > 0 }]">
		<input
			:class="[{ filled: filled }]"
			:type="type"
			:value="modelValue"
			:id="id"
			:required="required"
			ref="VInput"
			@input="$emit('update:modelValue', $event.target.value)"
		/>
		<label :for="id">{{ label }}</label>
		<div v-for="(error, i) in errorMessage" :key="i">
			<small class="d-block">
				{{ error }}
			</small>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			filled: false,
			nullValue: false,
		};
	},
	props: {
		type: {
			type: String,
			required: false,
			default: 'text',
		},
		id: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		modelValue: {
			type: String,
			required: false,
		},
		required: {
			type: Boolean,
			required: false,
			default: false,
		},
		errorMessage: {
			type: Array,
			required: false,
			defalut: [],
		},
	},
	methods: {
		isFilled() {
			if (this.modelValue && this.modelValue.length > 0)
				this.filled = true;
			else this.filled = false;
		},
	},
	mounted() {
		this.isFilled();
	},
	updated() {
		this.isFilled();
	},
};
</script>
